import HeaderSeparation from './HeaderSeparation';

export default HeaderSeparation;
